
define('jst!autocompleter/_loading',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<li class="item loading">\n    <div class="image-block">\n        <div class="img space-right">\n            <div class="icon-16 icon icon-spinner"></div>\n        </div>\n        <div class="bd"><%= t(\'Searching ...\') %> </div>\n    </div>\n</li>');
 });

